import { createPopper } from '@popperjs/core';

jQuery(document).ready(function($) {
    function showPopover($button, $popover) {
        $popover.show();
        popperInstance = createPopper($button[0], $popover[0], {
            placement: 'bottom',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 26],
                    },
                },
                {
                    name: 'arrow',
                    options: {
                        element: '.mega-menu-panel-arrow',
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 20, // Add padding around the viewport edge
                    },
                }
            ],
        });
    }

    function hidePopover($popover, popperInstance) {
        $popover.hide();
        if (popperInstance) {
            popperInstance.destroy();
            popperInstance = null;
        }
    }

     //Handle multiple buttons and panels
     const buttonPanelPairs = [
        { button: '.mega-menu-item-how-we-help', panel: '.mega-menu-panel-how-we-help' },
        { button: '.mega-menu-item-what-we-do', panel: '.mega-menu-panel-what-we-do' },
        { button: '.mega-menu-item-explore', panel: '.mega-menu-panel-explore' }
    ];

    let activePopperInstance = null;
    let $activePanel = null;

    buttonPanelPairs.forEach(({ button, panel }) => {
        const $button = $(button);
        const $panel = $(panel);

        $button.on('click', function(e) {
            // Disable links from going anywhere
            e.preventDefault();
            e.stopPropagation();

            if ($activePanel && $activePanel[0] !== $panel[0]) {
                hidePopover($activePanel, activePopperInstance);
            }

            if ($panel.is(':hidden')) {
                activePopperInstance = showPopover($button, $panel);
                $activePanel = $panel;
            } else {
                hidePopover($panel, activePopperInstance);
                activePopperInstance = null;
                $activePanel = null;
            }
        });
    });

    // Close panel if click outside the panel
    $(document).on('click', function(e) {
        if ($activePanel && !$(e.target).closest($activePanel).length && !$(e.target).closest('.mega-menu-item').length) {
            hidePopover($activePanel, activePopperInstance);
            activePopperInstance = null;
            $activePanel = null;
        }
    });
});